<template>
  <div class="flex flex-row items-center justify-between w-full">
    <div class="flex flex-row items-center gap-3 min-w-0">
      <div
        class="rounded-full w-11 h-11 flex-none flex items-center justify-center"
        :class="coupon.active && !isExpired ? 'bg-primary-50 text-primary' : 'bg-gray-100 text-gray-400'"
      >
        <i class="pi pi-tag text-lg" />
      </div>
      <div class="flex flex-col min-w-0">
        <div class="flex items-center gap-2">
          <span class="font-semibold tracking-wide truncate">{{ coupon.code }}</span>
          <span
            v-if="!coupon.active"
            class="text-[10px] px-2 py-[1px] rounded-full bg-gray-100 text-gray-500 flex-none"
          >לא פעיל</span>
          <span
            v-else-if="isExpired"
            class="text-[10px] px-2 py-[1px] rounded-full bg-red-50 text-red-500 flex-none"
          >פג תוקף</span>
        </div>
        <span class="text-sm text-gray-700">{{ discountLabel }}</span>
        <span class="text-[11px] text-gray-400">{{ subLabel }}</span>
      </div>
    </div>
    <i class="pi pi-angle-left text-gray-300 flex-none" />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { CouponDiscountTypeEnum, ICoupon } from '@torim-app/types';
import { DateTime } from 'luxon';

const props = defineProps({
  coupon: {
    type: Object as PropType<ICoupon>,
    required: true
  }
});

const isExpired = computed(() =>
  !!props.coupon.validUntil && DateTime.fromISO(props.coupon.validUntil as string) < DateTime.local()
);

const discountLabel = computed(() => {
  const c = props.coupon;
  if (c.discountType === CouponDiscountTypeEnum.Percentage) {
    return `${c.discountValue}% הנחה${c.maxDiscountAmount ? ` (עד ₪${c.maxDiscountAmount})` : ''}`;
  }
  return `₪${c.discountValue} הנחה`;
});

const subLabel = computed(() => {
  const c = props.coupon;
  const parts: string[] = [];
  const used = c.usageCount ?? 0;
  parts.push(c.usageLimit != null ? `נוצל ${used}/${c.usageLimit}` : `נוצל ${used} פעמים`);
  if (c.validUntil)
    parts.push(`עד ${DateTime.fromISO(c.validUntil as string).toLocaleString(DateTime.DATE_SHORT, { locale: 'he-IL' })}`);
  return parts.join(' · ');
});
</script>
